import { isEmpty } from "lodash";
import api from "../redux/api";
import qs from "qs";
import { handleNotificationMessage } from "./notifications";

export const pendingCall = (status) => status === "idle";

export const getVesselSystemDistinct = (query) =>
  new Promise((resolve, reject) => {
    api
      .get(
        `resource/vessel-system-distinct/${
          !isEmpty(query) ? `?${qs.stringify(query)}` : ""
        }`
      )
      .then((response) => resolve(response.data?.results))
      .catch((e) => console.log(e));
  });

export const openAuthorizedWindow = async (url, setReportReady) => {
  setReportReady(false);
  try {
    const { pdfUrl, fileName } = await getBlobUrl(url);
    setReportReady(true);

    return { pdfUrl, fileName };
  } catch (e) {
    handleNotificationMessage(undefined, undefined, e);
  }
  setReportReady(true);
  return { pdfUrl: "", fileName: "" };
};

export const getBlobUrl = async (url) => {
  const { data, headers } = await api.get(url, {
    responseType: "blob",
    timeout: 230000,
  });

  let fileName = `Report=${Date.now()}`;
  try {
    fileName = headers["content-disposition"]
      .split("=")[1]
      .replace('"', "")
      .replace('"', "");
  } catch (e) {
    console.log(e);
  }
  const pdfUrl = window.URL.createObjectURL(data);

  return { pdfUrl, fileName };
};
